import StringInput from "./stringInput.element";
import {CSSProperties, HTMLInputTypeAttribute} from "react";
import {Tooltip} from "@mui/material";
import {useFieldDoc} from "./useFieldDoc";

interface StringInputLabelProps {
    // Optional: omitted when `field` supplies the label from the model's [FieldDoc].
    title?: string;
    value: string;
    placeholder?: string;
    tooltip?: string;
    // Manifest field key — sources the label + tooltip from the Client model.
    field?: string;
    type?: HTMLInputTypeAttribute;
    inputStyle?: CSSProperties;
    onChange(value: string): void;
}

function StringInputLabel(props: StringInputLabelProps) {
    const {label, tip} = useFieldDoc({field: props.field, title: props.title, tooltip: props.tooltip});
    return (
        <div className={'layout horizontal stretch gap'} style={{alignItems: 'center', gap: 10}}>
            <div className={'layout horizontal center gap'}>
                {tip
                    ? <Tooltip title={tip} arrow disableInteractive>
                        <p style={{cursor: 'help'}}>{label}</p>
                    </Tooltip>
                    : <p>{label}</p>}
            </div>
            <StringInput value={props.value} placeholder={props.placeholder} type={props.type}
                         style={props.inputStyle} onChange={props.onChange}/>
        </div>
    )
}

export default StringInputLabel;
